import {initializeApp} from 'firebase/app';
import {ARGS} from "../../core/bootstrap/args";

const firebaseConfig = {
  apiKey: ARGS.FIREBASE_API_KEY,
  projectId: ARGS.FIREBASE_PROJECT_ID,
  appId: ARGS.FIREBASE_APP_ID
};

export const firebase = initializeApp(firebaseConfig);
